import { render, staticRenderFns } from "./ResellerOverview.vue?vue&type=template&id=1c27851b&scoped=true&"
import script from "./ResellerOverview.vue?vue&type=script&lang=js&"
export * from "./ResellerOverview.vue?vue&type=script&lang=js&"
import style0 from "./ResellerOverview.vue?vue&type=style&index=0&id=1c27851b&scoped=true&lang=css&"
import style1 from "./ResellerOverview.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ResellerOverview.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27851b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VDataTable,VDialog,VDivider,VIcon,VSelect,VSpacer,VSwitch})
